import styled from 'styled-components'

export const FiltersFastButtonsWrapper = styled.div`
  @media (max-width: 768px) {
    width: calc(100% + 20px);
    margin-left: -10px;
    overflow: auto;
    scrollbar-width: none; 
    -ms-overflow-style: none; 

    &::-webkit-scrollbar {
      display: none; 
    }
    
    button {
      &:first-child {
        margin-left: 10px;
      }
    }
  }
`

export const FiltersFastButtonsRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-wrap: nowrap;
  }
`